import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaginationState } from '../../models/pagination';
import { UnifiedProfilesTopbarTab } from '../../models/tabs';

type ListState = {
  pagination: PaginationState;
};

type UnifiedProfilesState = {
  ui: {
    tabs: UnifiedProfilesTopbarTab[];
    search: ListState;
  };
  lastSearches: string[];
};

export const initialState: UnifiedProfilesState = {
  ui: {
    tabs: [{ id: 'unifiedProfiles.search', current: true }],
    search: {
      pagination: {
        pageNo: 0,
        pageSize: 0,
      },
    },
  },
  lastSearches: [],
};

const unifiedProfilesSlice = createSlice({
  name: 'unifiedProfiles',
  initialState,
  reducers: {
    reset: (state) => ({
      ...initialState,
      lastSearches: state.lastSearches,
    }),
    setUnifiedProfilesTabs: (state, action: PayloadAction<UnifiedProfilesTopbarTab[]>) => ({
      ...state,
      ui: {
        ...state.ui,
        tabs: action.payload,
      },
    }),
    setSearchPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        search: {
          ...state.ui.search,
          pagination: action.payload,
        },
      },
    }),
    appendUnifiedSearch: (state, action: PayloadAction<string>) => {
      const newUniqueSearches = new Set([...state.lastSearches, action.payload]);
      const newSearches = [...newUniqueSearches];

      if (newUniqueSearches.size === 6) {
        newSearches.shift();
      }

      return {
        ...state,
        lastSearches: newSearches,
      };
    },
    deleteUnifiedSearch: (state, action: PayloadAction<string>) => ({
      ...state,
      lastSearches: state.lastSearches.filter((search) => search !== action.payload),
    }),
  },
});

export const { reset, setUnifiedProfilesTabs, setSearchPagination, deleteUnifiedSearch, appendUnifiedSearch } = unifiedProfilesSlice.actions;

export default unifiedProfilesSlice.reducer;
